import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { withStyles, Grid } from '@material-ui/core';

import DetailsBottomButtons from './DetailsBottomButtons';

const styles = ({ palette }) => ({
  container: {
    width: 326,
    overflow: 'hidden'
  },
  contentContainer: {
    maxHeight: 270,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 5
    },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: 3
    },
    '&::-webkit-scrollbar-thumb': {
      background: palette.scrollColor,
      borderRadius: 5
    }
  },
  content: {
    margin: 0,
    width: '100%'
  },
  item: {
    borderBottom: `1px solid ${palette.subTextColor}`,
    '&:hover': {
      background: palette.sideBar.itemHover.background
    }
  },
  itemText: {
    margin: 0
  },
  itemTitle: {
    color: `${palette.text.color}!important`
  },
  itemDescription: {
    color: `${palette.subTextColor}!important`
  }
});

function ButtonDetails({
  changeTabIndex, list, changeTab, setId, seeAll, readAll, classes
}) {
  return (
    <Grid container direction="column" className={classes.container} spacing={2}>
      <Grid item className={classes.contentContainer}>
        <Grid container spacing={2} direction="column" className={classes.content}>
          {!!list.length && list.map((item) => (
            <Grid
            item
            key={item.id || item.helpItemId}
            className={classes.item}
            onClick={() => {
              changeTab(item.id ? 3 : item.categoryIds[0]);
              setId(item.id || item.helpItemId);
            }}
          >
              <NavLink to="/help">
                <p className={`${classes.itemText} ${classes.itemTitle}`}>{item.title}</p>
                <p className={`${classes.itemText} ${classes.itemDescription}`}>{item.description}</p>
              </NavLink>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item>
        <DetailsBottomButtons
        changeTabIndex={changeTabIndex}
        seeAll={seeAll}
        changeTab={changeTab}
        readAll={readAll && !!list.length}
      />
      </Grid>
    </Grid>
  );
}

ButtonDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  changeTab: PropTypes.func.isRequired,
  setId: PropTypes.func.isRequired,
  seeAll: PropTypes.func.isRequired,
  list: PropTypes.array.isRequired,
  readAll: PropTypes.bool.isRequired,
  changeTabIndex: PropTypes.number.isRequired
};

export default withStyles(styles)(ButtonDetails);